// eslint-disable-next-line jira/restricted/react-component-props
import React, { Component, type ComponentProps } from 'react';
import type { Store } from 'redux';
import isEqual from 'lodash/isEqual';
import noop from 'lodash/noop';
import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import ViewTracker from '@atlassian/jira-analytics-web-react/src/components/view-tracker.tsx';
import AppBase from '@atlassian/jira-app-base/src/index.tsx';
import AppStyle from '@atlassian/jira-common-components-app-style/src/index.tsx';
import { FlagsDispatcher } from '@atlassian/jira-flags';
import flagsMapper from './flags/index.tsx';
import { initialQuery } from './model/constants.tsx';
import type { Props } from './model/index.tsx';
import rootEpic from './ops/index.tsx';
import { setAppProps } from './state/actions/app/index.tsx';
import {
	retrieve as retrieveBoards,
	retrieved as retrievedBoards,
} from './state/actions/boards/index.tsx';
import { setQuery } from './state/actions/query/index.tsx';
import createStore from './state/index.tsx';
import { getQuery } from './state/selectors/query/index.tsx';
import type { State } from './state/types.tsx';
import View from './view/index.tsx';

// eslint-disable-next-line jira/react/no-class-components
export default class Boards extends Component<Props> {
	static defaultProps = {
		query: undefined,
		prefetchedData: {},
		withPageReadyMetrics: true,
		onQueryChanged: noop,
		onUnmount: noop,
	};

	constructor(props: Props) {
		super(props);

		this.store = createStore(rootEpic);
		const { boards } = props.prefetchedData;
		const { dispatch } = this.store;

		dispatch(setAppProps(props));
		dispatch(setQuery(props.query || initialQuery));
		dispatch(boards ? retrievedBoards(boards) : retrieveBoards());
	}

	componentDidUpdate(prevProps: Props): void {
		const { dispatch } = this.store;
		const { query } = this.props;

		if (!isEqual(prevProps, this.props)) {
			dispatch(setAppProps(this.props));
		}

		if (query && !isEqual(query, getQuery(this.store.getState()))) {
			dispatch(setQuery(query));
			dispatch(retrieveBoards());
		}
	}

	componentWillUnmount(): void {
		this.props.onUnmount();
	}

	store: Store<State>;

	render(): React.JSX.Element {
		return (
			<AppBase store={this.store} hasErrorBoundary={false}>
				<ReportErrors id="unhandled" packageName="jiraBoardsMain" teamName="keystone">
					{/* @ts-expect-error - TS2322 - Type '(action: Action, state: State) => { type: string; title: { id: string; defaultMessage: string; description: string; }; } | { type: string; title: ({ id: string; defaultMessage: string; description: string; } | { ...; })[]; } | undefined' is not assignable to type 'FlagsMapper<Action, State>'. */}
					<FlagsDispatcher mapper={flagsMapper} />
					<ViewTracker />
					<AppStyle>
						{/* @ts-expect-error - TS2786 - Type 'any' is not assignable to type 'never'. */}
						<View />
					</AppStyle>
				</ReportErrors>
			</AppBase>
		);
	}
}

export type BoardsProps = JSX.LibraryManagedAttributes<
	typeof Boards,
	ComponentProps<typeof Boards>
>;
